
import { Component,Prop,Watch, BaseMixins } from '@/lib';

import appConfig from '@/config'
import { arrayHelper,menuRouteHelper } from '@/lib/utils';
import { Menu } from '@/types/iview/menu';

import SideMenuItem from './side-menu-item.vue'
import CollapsedMenu from './collapsed-menu.vue'

@Component({
  components:{SideMenuItem,CollapsedMenu}
})
export default class SideMenu extends BaseMixins {
    name:string='SideMenu';
    openedNames:Array<string>= [];
    @Prop({type:Array,default:function(){return [];}}) menuList:any;
    @Prop({type:Boolean,default:false}) collapsed:boolean;
    @Prop({type:String,default:'dark'}) theme:string;
    @Prop({type:Number,default:20}) rootIconSize:number;
    @Prop({type:Number,default:16}) iconSize:number;
    @Prop({type:Boolean,default:false}) accordion:boolean;
    @Prop({type:String,default:''}) activeName:string;
    @Prop({type:Array,default:function(){return [];}}) openNames:Array<any>;

    // annotate refs type.
    // The symbol `!` (definite assignment assertion)
    // is needed to get rid of compilation error.
    $refs!: {
        menu: Menu
    }

    get  textColor () {
      return this.theme === 'dark' ? '#fff' : '#495060'
    }

    handleSelect (name) {
      this.$emit('on-select', name)
    }
    getOpenedNamesByActiveName (name) {
      return this.$route.matched.map(item => item.name).filter(item => item !== name)
    }
    updateOpenName (name) {
      if (name === appConfig.homeName) this.openedNames = []
      else this.openedNames = this.getOpenedNamesByActiveName(name)
    }

    showTitle (item) {
      return menuRouteHelper.showTitle(item);
    }

    showChildren (item) {
      return item.children && (item.children.length > 1 || (item.meta && item.meta.showAlways))
    }

    getNameOrHref (item, children0) {
     let itemName:string = '';
     if(item.href){
        itemName = `isTurnByHref_${item.href}`;
      } else if(children0){
         let firstChild = item.children[0];
         if(firstChild.meta && firstChild.meta.defaultChild){
           itemName = firstChild.meta.defaultChild;
         }else{
           itemName = firstChild.name;
         }
       } else if(item.meta && item.meta.defaultChild){
        itemName = item.meta.defaultChild;
      }else {
        itemName = item.name;
      }
      //return item.href ? `isTurnByHref_${item.href}` : (children0 ? item.children[0].name : item.name)
      return itemName;
    }

    @Watch('activeName')
    activeNameChange (name) {
      if (this.accordion) this.openedNames = this.getOpenedNamesByActiveName(name)
      else this.openedNames = arrayHelper.getUnion(this.openedNames, this.getOpenedNamesByActiveName(name))
    }
    @Watch('openNames')
    openNameChange (newNames) {
      this.openedNames = newNames
    }
    @Watch('openedNames')
    openedNameChange () {
      this.$nextTick(() => {
        this.$refs.menu.updateOpened()
      })
    }

    mounted() {
        this.openedNames = arrayHelper.getUnion(this.openedNames, this.getOpenedNamesByActiveName(name))
    }
}
